/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Tools_Pick_Integration_HintInputs */



/**
* | output |
* | --- |
* | "Select an integration to configure its tool access." |
*
* @param {Rights_Tools_Pick_Integration_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_tools_pick_integration_hint = /** @type {((inputs?: Rights_Tools_Pick_Integration_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Tools_Pick_Integration_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie eine Integration, um deren Tool-Zugriff zu konfigurieren.")
	return /** @type {LocalizedString} */ ("Select an integration to configure its tool access.")
});